import { faWrench } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { useMaintenanceMode } from '@quality24/react-maintenance-mode';
import { Icon, Text } from '@quality24/design-system';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './MaintenanceMode.module.scss';

export interface Props {
  className?: string;
}

const MaintenanceMode: React.FunctionComponent<Props> = ({ className }) => {
  const { t } = useTranslation();
  const { isEnabled } = useMaintenanceMode();

  return isEnabled ? (
    <div className={classNames(styles.wrapper, className)}>
      <div className={styles.header} />
      <div className={styles.content}>
        <div>
          <Icon icon={faWrench} size="xl" />
          <Text className="text-1">{t('maintenance.title')}</Text>
          <Text className="text-2">{t('maintenance.body')}</Text>
        </div>
      </div>
    </div>
  ) : null;
};

export default MaintenanceMode;
